import React, { FC } from 'react';

import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteContractorLegalMutation } from 'bus/contractorLegal/services/services';

type DetailModalRoleProps = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DetailModalRole: FC<DetailModalRoleProps> = (props) => {
  const [deleteContractorLegal] = useDeleteContractorLegalMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    await deleteContractorLegal({ id: props.id! });
    props.refresh();
    props.changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить юр. лицо?</div>

            <ModalFooter
              useSubmitBehavior={true}
              handleSubmit={handleSubmit}
              hideModal={() => props.changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DetailModalRole;
